import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyQuery, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from '@ngx-translate/core';
class OfferSearchBarComponent {
    constructor(companyQuery) {
        this.companyQuery = companyQuery;
        this.searchResultArray = new EventEmitter();
    }
    ngOnInit() { }
    search() {
        const companies = this.companyQuery.getAll();
        if (!this.searchText) {
            this.searchResultArray.emit(this.arrayToFilter);
            return;
        }
        const filteredCompanyIds = companies
            .filter((c) => c.DisplayName.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase().trim()))
            .map((o) => o.CompanyId);
        const filteredOffers = this.arrayToFilter.filter((o) => filteredCompanyIds.includes(o.CompanyId));
        this.searchResultArray.emit(filteredOffers);
    }
}
OfferSearchBarComponent.ɵfac = function OfferSearchBarComponent_Factory(t) { return new (t || OfferSearchBarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.CompanyQuery)); };
OfferSearchBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: OfferSearchBarComponent, selectors: [["fgbcl-offer-search-bar"]], inputs: { arrayToFilter: "arrayToFilter" }, outputs: { searchResultArray: "searchResultArray" }, decls: 8, vars: 10, consts: [[1, "input-group"], [1, "form-outline"], ["type", "search", "id", "form1", 1, "form-control", 3, "ngModel", "ngModelChange", "input"], ["type", "button", 1, "btn", "btn-primary", 3, "click"], [1, "icon", "icon-magnifier-1"]], template: function OfferSearchBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function OfferSearchBarComponent_Template_input_ngModelChange_2_listener($event) { return ctx.searchText = $event; })("input", function OfferSearchBarComponent_Template_input_input_2_listener() { return ctx.search(); });
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "button", 3);
        ɵngcc0.ɵɵlistener("click", function OfferSearchBarComponent_Template_button_click_5_listener() { return ctx.search(); });
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelement(7, "i", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.searchText);
        ɵngcc0.ɵɵattribute("placeholder", ɵngcc0.ɵɵpipeBind1(3, 4, "offers.search.placeholder"))("aria-label", ɵngcc0.ɵɵpipeBind1(4, 6, "offers.search.input.screenreader"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(6, 8, "offers.search.button.screenreader"));
    } }, directives: [ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgModel], pipes: [ɵngcc3.TranslatePipe], styles: ["button[_ngcontent-%COMP%]{margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}"] });
OfferSearchBarComponent.ctorParameters = () => [
    { type: CompanyQuery }
];
OfferSearchBarComponent.propDecorators = {
    arrayToFilter: [{ type: Input }],
    searchResultArray: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OfferSearchBarComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-offer-search-bar',
                template: "<div class=\"input-group\">\r\n  <div class=\"form-outline\">\r\n    <input\r\n      type=\"search\"\r\n      id=\"form1\"\r\n      class=\"form-control\"\r\n      attr.placeholder=\"{{ 'offers.search.placeholder' | translate }}\"\r\n      attr.aria-label=\"{{ 'offers.search.input.screenreader' | translate }}\"\r\n      [(ngModel)]=\"searchText\"\r\n      (input)=\"search()\"\r\n    />\r\n  </div>\r\n  <button\r\n    type=\"button\"\r\n    class=\"btn btn-primary\"\r\n    attr.aria-label=\"{{ 'offers.search.button.screenreader' | translate }}\"\r\n    (click)=\"search()\"\r\n  >\r\n    <i class=\"icon icon-magnifier-1\"></i>\r\n  </button>\r\n</div>\r\n",
                styles: ["button{margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}"]
            }]
    }], function () { return [{ type: ɵngcc1.CompanyQuery }]; }, { searchResultArray: [{
            type: Output
        }], arrayToFilter: [{
            type: Input
        }] }); })();

class OfferSearchBarModule {
}
OfferSearchBarModule.ɵfac = function OfferSearchBarModule_Factory(t) { return new (t || OfferSearchBarModule)(); };
OfferSearchBarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: OfferSearchBarModule });
OfferSearchBarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(OfferSearchBarModule, { declarations: function () { return [OfferSearchBarComponent]; }, imports: function () { return [CommonModule,
        FormsModule, ɵngcc3.TranslateModule]; }, exports: function () { return [OfferSearchBarComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OfferSearchBarModule, [{
        type: NgModule,
        args: [{
                declarations: [OfferSearchBarComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [OfferSearchBarComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { OfferSearchBarComponent, OfferSearchBarModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-club-offer-search-bar.js.map